import { jsx as t } from "react/jsx-runtime";
import { u as y, f as p, F as C } from "../../../floating-ui.react--Sr3isS-.js";
import { forwardRef as b, isValidElement as R } from "react";
import { MarketTheme as k } from "../../MarketTheme/MarketTheme.js";
import T from "../hooks/usePopoverContext.js";
import E from "../hooks/usePopoverTransition.js";
const I = b((f, m) => {
  const {
    children: o,
    style: u,
    initialFocus: r,
    ...n
  } = f, {
    container: v = "div",
    context: a,
    disableFocusManager: i,
    layerMode: s,
    portalRootId: g,
    ...e
  } = T(), l = R(o) ? o.ref : void 0, c = [e.refs.setFloating, m];
  l && c.push(l);
  const x = y(c), { status: h, visible: F, onTransitionEnd: P } = E();
  if (!F)
    return null;
  const M = e.getFloatingProps(n), d = /* @__PURE__ */ t(
    v,
    {
      ref: x,
      "data-placement": e.placement,
      "data-status": h.current,
      popover: s === "native" ? "manual" : void 0,
      style: { ...e.floatingStyles, zIndex: 1e3, ...u },
      onTransitionEnd: P,
      ...M,
      ...n,
      children: o
    }
  );
  return s === "native" ? /* @__PURE__ */ t(
    p,
    {
      initialFocus: r,
      context: a,
      disabled: i,
      modal: !1,
      children: d
    }
  ) : /* @__PURE__ */ t(C, { id: g, children: /* @__PURE__ */ t(
    p,
    {
      initialFocus: r,
      context: a,
      disabled: i,
      modal: !1,
      children: /* @__PURE__ */ t(k, { portal: !0, children: d })
    }
  ) });
});
I.displayName = "MarketPopoverContent";
export {
  I as MarketPopoverContent
};
